import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import window from 'window-or-global';
import { isFedRamp as isFedRampAtlContext } from '@atlassian/atl-context';
import { getAppName } from '../app';
import { getEnv } from '../env';
import { LOCAL_PRODUCTION_BACKEND } from '../globals';
// default configs is also config for production env
var productionConfig = {
  stargateRoot: '/gateway/api',
  analytics: {
    scheme: 'https',
    server: 'analytics.atlassian.com'
  },
  feedbackIssueCollectorId: '908df207',
  atlassianAccountUrl: 'https://id.atlassian.com',
  permsServiceUrl: '/gateway/api/permissions',
  collaborationGraph: '/gateway/api/collaboration',
  emojiUrl: '/gateway/api/emoji/standard',
  teamCentralUrl: 'https://team.atlassian.com',
  // TODO: https://product-fabric.atlassian.net/browse/TC-10338
  teamCentralReactionUrl: '/gateway/api/watermelon/reactions'
};
var devAndStagingConfig = {
  stargateRoot: '/gateway/api',
  analytics: {
    scheme: 'https',
    server: 'analytics.atlassian.com'
  },
  feedbackIssueCollectorId: '908df207',
  atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
  permsServiceUrl: '/gateway/api/permissions',
  collaborationGraph: '/gateway/api/collaboration',
  emojiUrl: '/gateway/api/emoji/standard',
  teamCentralUrl: 'https://team.stg.atlassian.com',
  // TODO: https://product-fabric.atlassian.net/browse/TC-10338
  teamCentralReactionUrl: '/gateway/api/watermelon/reactions'
};
var localAndTestConfig = {
  stargateRoot: '/gateway/api',
  analytics: {
    scheme: 'http',
    server: 'localhost:3000'
  },
  feedbackIssueCollectorId: '908df207',
  atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
  permsServiceUrl: '/gateway/api/permissions',
  collaborationGraph: '/gateway/api/collaboration',
  emojiUrl: '/gateway/api/emoji/standard',
  teamCentralUrl: 'https://team.stg.atlassian.com',
  // TODO: https://product-fabric.atlassian.net/browse/TC-10338
  teamCentralReactionUrl: '/gateway/api/watermelon/reactions'
};
var fedrampConfig = {
  stargateRoot: '/gateway/api',
  analytics: {
    scheme: 'https',
    server: 'analytics.atlassian.com'
  },
  feedbackIssueCollectorId: '908df207',
  atlassianAccountUrl: 'https://id.atlassian-us-gov-mod.com',
  permsServiceUrl: '/gateway/api/permissions',
  collaborationGraph: '/gateway/api/collaboration',
  emojiUrl: '/gateway/api/emoji/standard',
  teamCentralDisabled: true,
  teamCentralReactionDisabled: true
};
var EnvOverrideKeys = ['adev', 'stg-east', 'local', 'test', 'fedramp', 'prod-east'];
var environmentOverrides = {
  'prod-east': productionConfig,
  local: _objectSpread(_objectSpread({}, LOCAL_PRODUCTION_BACKEND ? productionConfig : localAndTestConfig), {}, {
    analytics: {
      scheme: 'http',
      server: "".concat(window.location.hostname, ":3000")
    }
  }),
  test: _objectSpread({}, localAndTestConfig),
  adev: devAndStagingConfig,
  'stg-east': devAndStagingConfig,
  fedramp: fedrampConfig
};
var cachedConfig = {};
export function isFedramp() {
  return isFedRampAtlContext();
}
export function getConfig() {
  var env = isFedramp() ? 'fedramp' : getEnv();
  var appName = getAppName();
  var key = "".concat(env, "_").concat(appName);
  if (!cachedConfig[key]) {
    if (EnvOverrideKeys.includes(env)) {
      cachedConfig[key] = _objectSpread({}, environmentOverrides[env]);
    } else {
      // fallback to prod as customers can have custom domains.
      cachedConfig[key] = _objectSpread({}, environmentOverrides['prod-east']);
    }
  }
  return cachedConfig[key];
}